exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1x64zZzP8Mz61Z{margin-top:30px}._1x64zZzP8Mz61Z button{margin-right:8px}@media only screen and (max-width:1020px){._5Gv97pnlDCJV-g{width:100%;min-width:375px}}", ""]);

// exports
exports.locals = {
	"buttons": "_1x64zZzP8Mz61Z",
	"illustration": "_5Gv97pnlDCJV-g"
};